import * as React from 'react'
export const SvgPaymentOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M22 5v14H2V5h20zm-2 5.5H4V17h16v-6.5zM9 14v2H5v-2h4zm11-7H4v1.5h16V7z" />
  </svg>
)
export default SvgPaymentOutline
